export class Account {
  async all(params) {
    const esc = encodeURIComponent
    const query = Object.keys(params)
      .filter(k => params[k])
      .map(k => esc(k) + "=" + esc(params[k]))
      .join("&")
    const response = await fetch("/admin/accounts?" + query, {
      method: "GET",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("meta[name=csrf-token]").content
      }
    })

    return await response.json()
  }

  async createAccount(user, registration, params) {
    const response = await fetch("/users", {
      method: "POST",
      credentials: "include",
      body: JSON.stringify({
        user,
        registration,
        ...params
      }),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("meta[name=csrf-token]").content
      }
    })

    return await response.json()
  }

  async whitelist(accountId) {
    const response = await fetch(`/admin/accounts/${accountId}/whitelist`, {
      method: "PUT",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("meta[name=csrf-token]").content
      }
    })

    return await response.json()
  }

  async blacklist(accountId) {
    const response = await fetch(`/admin/accounts/${accountId}/blacklist`, {
      method: "PUT",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("meta[name=csrf-token]").content
      }
    })

    return await response.json()
  }

  async whitelistRemove(accountId) {
    const response = await fetch(
      `/admin/accounts/${accountId}/whitelist_remove`,
      {
        method: "PUT",
        credentials: "include",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector("meta[name=csrf-token]")
            .content
        }
      }
    )

    return await response.json()
  }

  async blacklistRemove(accountId) {
    const response = await fetch(
      `/admin/accounts/${accountId}/blacklist_remove`,
      {
        method: "PUT",
        credentials: "include",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector("meta[name=csrf-token]")
            .content
        }
      }
    )

    return await response.json()
  }
}
